var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBook = function SvgBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 3c0-.08.03-.134.074-.177a.27.27 0 0 1 .177-.073H7.25v14.5H5a.23.23 0 0 1-.177-.074A.27.27 0 0 1 4.75 17V3Zm4 14.25H15a.23.23 0 0 0 .177-.074.27.27 0 0 0 .073-.176V3c0-.08-.03-.134-.074-.177a.27.27 0 0 0-.177-.073H8.75v14.5ZM5 1.25c-.864 0-1.75.687-1.75 1.75v14c0 .865.689 1.75 1.75 1.75h10c1.061 0 1.75-.885 1.75-1.75V3c0-1.063-.886-1.75-1.75-1.75H5Z",
    fill: "currentColor"
  })));
};
export default SvgBook;